
export const BrandData=[
    {
        id:1,
        brandName:"CLINIQUE",
		searchName:"clinique",
        description:"Explore Clinique's wide range of skincare, makeup and fragrance. Find products that fit your skin and routine. Free samples | 10% off on first purchase.",
    },
    {
        id:2,
        brandName:"MAYBELLINE",
		searchName:"maybelline",
        description:"Select from the latest range of Maybelline foundations, lipstick, eyeshadows & more cosmetics",

    },
    {
        id:3,
        brandName:"L'OREAL",
		searchName:"loreal",
        description:"Offering all women and men worldwide the best of cosmetics, haircare and perfume in terms of quality, efficacy and safety",

    },
    {
        id:4,
        brandName:"COVERGIRL",
		searchName:"covergirl",
        description:"Face and eye makeup, lipstick, makeup tools and pro tips. Check out our COVERGIRL Collections including TruBlend, Outlast, Blast and more.",

    },
    {
        id:5,
        brandName:"NYX",
		searchName:"nyx",
        description:"Discover NYX Professional Makeup & beauty products today on our  site and shop all of our new products, best sellers plus much more!",

    },
    {
        id:6,
        brandName:"COLOUR POP",
		searchName:"colourpop",
        description:"With single items $8 & under, it's impossible to not want to try them all!"

    }

]
export const productsData=[
        {
            id:1,
            productName:"LIPSTICK"
        },
        {
            id:2,
            productName:"FOUNDATION"
        },
        {
            id:3,
            productName:"MASCARA"
        },
        {
            id:4,
            productName:"EYELINER"
        },
        {
            id:5,
            productName:"BRONZER"
        },
        {
            id:6,
            productName:"BLUSH"
        }
    ]

 

	export const shades=[
		{
			"hex_value" : "#000000",
			"colour_name" : "Black "
		},
		{
			"hex_value" : "#3E2829",
			"colour_name" : "Brown "
		}
	]